<div
  class="component-container"
  [style.backgroundColor]="config().backgroundColor"
  data-cy="won_message"
>
  <div class="left">
    <img
      [alt]="config().left.winCardImage.alternativeText | replaceVars: amount()"
      class="max-img"
      [src]="config().left.winCardImage.imageUrl"
    />
    <div class="text-container">
      <p
        class="win-first-label"
        [style]="{
          color: config().left.winFirstLabel.color,
          fontFamily: config().left.winFirstLabel.fontFamily,
        }"
        [innerHTML]="config().left.winFirstLabel.text"
      ></p>

      <p class="amount" [style.fontFamily]="config().left.amount.fontFamily">
        {{ amount() | formatReward }}
      </p>
      <p
        class="win-second-label"
        [style]="{
          color: config().left.winSecondLabel.color,
          fontFamily: config().left.winSecondLabel.fontFamily,
        }"
        [innerHTML]="config().left.winSecondLabel.text"
      ></p>
    </div>
  </div>
  <div class="right">
    <div class="win-right-label">
      <img
        [src]="config().right.logo.imageUrl"
        [alt]="config().right.logo.alternativeText"
        class="right-image"
      />
      <p
        class="right-label"
        [style]="{
          color: config().right.winRightLabel.color,
          fontFamily: config().right.winRightLabel.fontFamily,
        }"
        [innerHTML]="config().right.winRightLabel.text"
      ></p>
    </div>
  </div>
</div>
